import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'
import { LanguageSelectSimple } from '@/components-latest/shared/LanguageSelect'

import Styles from './SmallFooter.module.scss'

export const SmallFooter = () => {
  const { t } = useTranslation()

  const SMALL_FOOTER_LINKS = [
    {
      url: 'https://food-stg-admin.yassir.io/app/site/public/pdf/cg.pdf',
      text: t('footer.terms-and-conditions')
    },
    {
      url: 'https://food-stg-admin.yassir.io/app/site/public/pdf/cdc.pdf',
      text: t('footer.confidentiality')
    }
  ]

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.content} data-testid="small-footer">
        <img src="/images/express-logo-white.svg" alt="logo" />
        <div className={Styles.links}>
          <Text asChild>
            <p>{t('footer.copyright')}</p>
          </Text>
          {SMALL_FOOTER_LINKS.map(({ url, text }, index) => (
            <Text key={index} asChild>
              <a
                className={Styles.link}
                href={url}
                target="_blank"
                rel="noreferrer">
                {text}
              </a>
            </Text>
          ))}
        </div>
        <LanguageSelectSimple className={Styles.select} />
      </div>
    </div>
  )
}
